/* *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 *
 * Copyright 2024 - Koninklijk Nederlands Meteorologisch Instituut (KNMI)
 * Copyright 2024 - Finnish Meteorological Institute (FMI)
 * Copyright 2024 - The Norwegian Meteorological Institute (MET Norway)
 * */

import { createListenerMiddleware } from '@reduxjs/toolkit';
import { metronome } from '@opengeoweb/metronome';
import { olMetronomeHandler } from './olMapListenerAnimationUtils';
import { mapActions } from './reducer';
import type { CoreAppStore } from '../../types';

export const metronomeListener = createListenerMiddleware<CoreAppStore>();

metronomeListener.startListening({
  actionCreator: mapActions.mapStartAnimation,
  effect: async (_, listenerApi) => {
    // register handler with access to listenerApi
    metronome.handleTimerTicks = (timerIds: string[]): void => {
      olMetronomeHandler(timerIds, listenerApi);
    };
  },
});
